export const ADVISOR = 'Advisor'
export const INVESTOR = 'Investor'

export const SITE_USER_TYPE_DCIO = 'FP-DCIO'
export const SITE_USER_TYPE_RIA = 'FP-RIA'
export const SITE_USER_TYPE_MF = 'Mutual-Fund-Accounts'
export const SITE_USER_TYPE_529 = '529-Accounts'
export const SITE_USER_TYPE_RETIREMENT = 'Retirement-Accounts'
export const SITE_USER_TYPE_INSTITUTIONAL = 'Institutional-Investors'

export function getSite() {
  const path = window.location.pathname
  if (
    path &&
    (path.indexOf('/cti-investor/') >= 0 || path.indexOf('/investor/') >= 0)
  ) {
    return INVESTOR
  } else {
    return ADVISOR
  }
}
